import axios from 'axios'
import {PUBLIC_URL} from 'api/config'
var qs = require('qs')

export function getDepartment (parameter) {
  const url = PUBLIC_URL + 'department/getDepartment'

  return axios.post(url, qs.stringify(parameter), {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  }).then((res) => {
    return Promise.resolve(res.data)
  })
}

export function getDepartmentDesc (parameter) {
  const url = PUBLIC_URL + 'department/getDepartmentDesc'

  return axios.post(url, qs.stringify(parameter), {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  }).then((res) => {
    return Promise.resolve(res.data)
  })
}



// WEBPACK FOOTER //
// ./src/api/post.js